import { BehaviorSubject } from "rxjs";
import FormBuilderService from "./form-builder.service";
import { diffForms } from "../utility/FormDiffUtils";

const formBuilderService = new FormBuilderService();
const compareRevisionState = new BehaviorSubject({});
const versionListState = new BehaviorSubject({ loading: false, versions: [] });

class FormVersionStore {
  // Loads the full version history for the compare picker.
  loadVersionHistory = (formCode) => {
    versionListState.next({ loading: true, versions: [] });
    formBuilderService
      .getAllPreviousVersionForms(formCode)
      .then((res) => {
        if (res?.data) {
          versionListState.next({ loading: false, versions: res.data });
        } else {
          versionListState.next({
            loading: false,
            versions: [],
            error: "Could not load version history.",
          });
        }
      })
      .catch(() => {
        versionListState.next({
          loading: false,
          versions: [],
          error: "Could not load version history.",
        });
      });
  };

  compareRevisions = async (currentRevision, previousRevision) => {
    compareRevisionState.next({ loading: true });
    try {
      const [currentRes, previousRes] = await Promise.all([
        formBuilderService.getForm(currentRevision.id),
        formBuilderService.getForm(previousRevision.id),
      ]);
      const currentForm = currentRes?.data;
      const previousForm = previousRes?.data;
      if (!currentForm || !previousForm) {
        compareRevisionState.next({
          loading: false,
          error: "Could not load revisions to compare.",
        });
        return;
      }
      compareRevisionState.next({
        loading: false,
        diff: diffForms(previousForm, currentForm),
        current: currentRevision,
        previous: previousRevision,
      });
    } catch (error) {
      compareRevisionState.next({
        loading: false,
        error: "Could not compare revisions.",
      });
    }
  };
}

const formVersionStore = new FormVersionStore();

export { formVersionStore, compareRevisionState, versionListState };
